/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ImageSvg from '../image/ImageSvg';
import VerificationBenefits from './VerificationBenefits';

const VerificationHeader = (props) => {
  const { verificationStatus, restricted } = props;

  let title = '';
  let description = '';
  let icon = 'icon--grey';
  if (restricted) {
    title = ['verified', 'pending'].includes(verificationStatus) ? 'txt: Verifikācijas process ir apturēts' : 'txt: Profils nav verificēts';
  } else {
    switch (verificationStatus) {
      case 'verified':
        title = 'txt: Verificēts profils';
        description = 'txt: Paldies! Tavs profils ir verificēts';
        icon = 'icon--blue';
        break;
      case 'pending':
        title = 'txt: Gaida verifikāciju';
        description = 'txt: Mēs saņēmām Tavu fotogrāfiju, apstiprināsim to kolīdz varēsim';
        break;
      default:
        title = 'txt: Profils nav verificēts';
        break;
    }
  }

  return (
    <div className="mbm pbl bbl">
      <ImageSvg svg="icon-check-2" iconClass={`${icon} icon--verification dib vam`} />
      <div className="dib vam mlxs">{get(translations, title, '')}</div>
      {description && (
        <div className="mtm">{get(translations, description, '')}</div>
      )}
      <VerificationBenefits />
    </div>
  );
};

VerificationHeader.propTypes = {
  verificationStatus: PropTypes.string,
  restricted: PropTypes.bool,
};

VerificationHeader.defaultProps = {
  verificationStatus: '',
  restricted: false,
};

export default VerificationHeader;
